
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
  },
  components: {
    MuiCssBaseline: {

      styleOverrides: {
        // body: darkScrollbar()
      },
    },
  }
});

export const globalStyles = {
  body: {
      padding: '16px', // Set global padding
      margin: 0,
  },
};


export default theme

